export default {
  headline: 'Model does not support nitrogen',
  text: 'The recipe you chose needs nitrogen, but the model does not provide nitrogen capacity. Choose a different model or recipe.',
};
